import React, { useState, useEffect } from "react";
import { db } from "./firebase_config";
import { collection, query, where, getDocs, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./GenerateBill.css";

const GenerateBill = () => {
  const navigate = useNavigate();

  const [activeDays, setActiveDays] = useState("");
  const [perDayAmount, setPerDayAmount] = useState("");
  const [estbFees, setEstbFees] = useState("");
  const [specialFees, setSpecialFees] = useState("");
  const [others, setOthers] = useState("");
  const [currentMonth, setCurrentMonth] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const today = new Date();
    const month = today.toLocaleString("default", { month: "2-digit" });
    const year = today.getFullYear();
    setCurrentMonth(`${year}-${month}`);
  }, []);
  const calculateMessCut = (messCuts, perDayAmount, previousMonth, previousYear) => {
    if (!Array.isArray(messCuts)) return 0;
  
    const messCutDates = messCuts
      .flatMap((range) => range.dates || [])
      .filter((date) => {
        const parsedDate = new Date(Date.parse(date));
        return (
          !isNaN(parsedDate) &&
          parsedDate.getMonth() === previousMonth &&
          parsedDate.getFullYear() === previousYear
        );
      });
  
    return messCutDates.length * perDayAmount * (66.66 / 100); // Assuming 66.66% deduction rate
  };
  const calculateFinalAmount = ({
    activeDays,
    perDayAmount,
    messCutAmount,
    deductions,
    fine,
    estbFees,
    specialFees,
    others,
  }) => {
    const baseAmount = activeDays * perDayAmount;
    const totalFees = estbFees + specialFees + others;
    const totalDeductions = messCutAmount + deductions + fine;
    return baseAmount + totalFees - totalDeductions;
  };
  
  const handleGenerateBill = async () => {
    setError("");
  
    try {
      const usersCollectionRef = collection(db, "sahrudaya_mess");
      const userQuery = query(usersCollectionRef);
      const querySnapshot = await getDocs(userQuery);
  
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();
  
      let previousMonth = currentMonth - 1;
      let previousYear = currentYear;
      if (previousMonth < 0) {
        previousMonth = 11; // December
        previousYear -= 1;
      }
      const previousMonthYear = `${previousYear}-${String(previousMonth + 1).padStart(2, "0")}`;
  
      querySnapshot.forEach(async (userDoc) => {
        const userData = userDoc.data();
  
        const perDayAmountValue = parseFloat(perDayAmount) || 0;
  
        // Calculate mess cut amount for the previous month
        const messCutAmount = calculateMessCut(userData.messCuts, perDayAmountValue, previousMonth, previousYear);
  
        // Other calculations (fine, deductions, etc.)
        let totalFine = 0;
        let totalDeductions = 0;
  
        if (
          userData.fine &&
          typeof userData.fine === "object" &&
          userData.fine[previousMonth]
        ) {
          const monthlyFines = userData.fine[previousMonth];
          if (Array.isArray(monthlyFines)) {
            totalFine = monthlyFines.reduce(
              (acc, fineEntry) => acc + (fineEntry.amount || 0),
              0
            );
          }
        }
  
        if (
          userData.deduction &&
          typeof userData.deduction === "object" &&
          userData.deduction[previousMonth]
        ) {
          const monthlyDeductions = userData.deduction[previousMonth];
          if (Array.isArray(monthlyDeductions)) {
            totalDeductions = monthlyDeductions.reduce(
              (acc, deductionEntry) => acc + (deductionEntry.amount || 0),
              0
            );
          }
        }
  
        const fineValue = totalFine || 0;
        const deductionsValue = totalDeductions || 0;
        const estbFeesValue = parseInt(estbFees) || 0;
        const specialFeesValue = parseInt(specialFees) || 0;
        const othersValue = parseInt(others) || 0;
        const activeDaysValue = parseInt(activeDays) || 0;
  
        const finalAmount = calculateFinalAmount({
          activeDays: activeDaysValue,
          perDayAmount: perDayAmountValue,
          messCutAmount,
          deductions: deductionsValue,
          fine: fineValue,
          estbFees: estbFeesValue,
          specialFees: specialFeesValue,
          others: othersValue,
        });
  
        const billData = {
          activeDays: activeDaysValue,
          fine: fineValue,
          specialFees: specialFeesValue,
          perDayAmount: perDayAmountValue,
          establishment: estbFeesValue,
          others: othersValue,
          amount: activeDaysValue * perDayAmountValue,
          deductions: deductionsValue,
          messCutAmount,
          totalMessCuts: messCutAmount / (perDayAmountValue * (66.66 / 100)), // Reverse calculate total mess cuts
          finalAmount,
          date: new Date().toISOString(),
        };
  
        await setDoc(
          userDoc.ref,
          { billAmount: { [previousMonthYear]: billData } },
          { merge: true }
        );
      });
  
      alert("Bills generated successfully for the previous month!");
    } catch (error) {
      console.error("Error generating bills:", error);
      setError("An error occurred while generating the bills. Please try again.");
    }
  };
  
  return (
    <div>
      <div className="app-bar">
        <button onClick={() => navigate("/profile")} className="back-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="back-icon"
          >
            <path
              fillRule="evenodd"
              d="M15.78 4.22a.75.75 0 01.07 1.06L9.31 12l6.54 6.72a.75.75 0 11-1.1 1.02l-7-7.2a.75.75 0 010-1.02l7-7.2a.75.75 0 011.06-.1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div className="app-bar-title">Generate Bill</div>
      </div>
      <div className="container">
        {error && <div className="alert">{error}</div>}
        <div className="form-control">
          <label>
            Active Days:
            <input
              type="number"
              value={activeDays}
              onChange={(e) => setActiveDays(e.target.value)}
              placeholder="Enter active days"
            />
          </label>
        </div>
        <div className="form-control">
          <label>
            Per Day Amount:
            <input
              type="number"
              value={perDayAmount}
              onChange={(e) => setPerDayAmount(e.target.value)}
              placeholder="Enter per day amount"
            />
          </label>
        </div>
        <div className="form-control">
          <label>
            Establishment Fees:
            <input
              type="number"
              value={estbFees}
              onChange={(e) => setEstbFees(e.target.value)}
              placeholder="Enter establishment fees"
            />
          </label>
        </div>
        <div className="form-control">
          <label>
            Special Fees:
            <input
              type="number"
              value={specialFees}
              onChange={(e) => setSpecialFees(e.target.value)}
              placeholder="Enter special fees"
            />
          </label>
        </div>
        <div className="form-control">
          <label>
            Others:
            <input
              type="number"
              value={others}
              onChange={(e) => setOthers(e.target.value)}
              placeholder="Enter other charges"
            />
          </label>
        </div>
        <button onClick={handleGenerateBill}>Generate Bill</button>
      </div>
    </div>
  );
};

export default GenerateBill;


//for clearing the billAmount

// const clearBillAmountMap = async () => {
//   try {
//     const usersCollectionRef = collection(db, "users");
//     const userQuery = query(usersCollectionRef);

//     const querySnapshot = await getDocs(userQuery);

//     querySnapshot.forEach(async (userDoc) => {
//       await setDoc(
//         userDoc.ref,
//         { billAmount: {} },
//         { merge: true }
//       );
//     });

//     console.log("BillAmount map cleared successfully for all users.");
//   } catch (error) {
//     console.error("Error clearing BillAmount map:", error);
//   }
// };